import { SERVER_API_URL } from "../constants/constants";
import axios from "axios";

// Video Analytics
const getTotalViews = async (startingtime, endingtime, userId = null) => {
  const getToken = localStorage.getItem("token");
  const config = {
    headers: { Authorization: `Bearer ${getToken}` },
  };
  
  let url = `${SERVER_API_URL}/admin/analytics/getTotalViews/${startingtime}/${endingtime}`;
  if (userId) {
    url += `/${userId}`;
  }
  
  const result = await axios.get(url, config);
  return result.data;
};

const getFeedTotalViews = async (startingtime, endingtime, userId = null) => {
  const getToken = localStorage.getItem("token");
  const config = {
    headers: { Authorization: `Bearer ${getToken}` },
  };
  
  let url = `${SERVER_API_URL}/admin/analytics/getFeedTotalViews/${startingtime}/${endingtime}`;
  if (userId) {
    url += `/${userId}`;
  }
  
  const result = await axios.get(url, config);
  return result.data;
};

// Coin Analytics
const getCoinAnalytics = async (startingtime, endingtime, userId = null) => {
  const getToken = localStorage.getItem("token");
  const config = {
    headers: { Authorization: `Bearer ${getToken}` },
  };
  
  let url = `${SERVER_API_URL}/admin/analytics/getCoinAnalytics/${startingtime}/${endingtime}`;
  if (userId) {
    url += `/${userId}`;
  }
  
  const result = await axios.get(url, config);
  return result.data;
};

const getSentCoinsAnalytics = async (startingtime, endingtime, userId = null) => {
  const getToken = localStorage.getItem("token");
  const config = {
    headers: { Authorization: `Bearer ${getToken}` },
  };
  
  let url = `${SERVER_API_URL}/admin/analytics/getSentCoinsAnalytics/${startingtime}/${endingtime}`;
  if (userId) {
    url += `/${userId}`;
  }
  
  const result = await axios.get(url, config);
  return result.data;
};

// Engagement Analytics
const getCommentAnalytics = async (startingtime, endingtime, userId = null) => {
  const getToken = localStorage.getItem("token");
  const config = {
    headers: { Authorization: `Bearer ${getToken}` },
  };
  
  let url = `${SERVER_API_URL}/admin/analytics/getCommentAnalytics/${startingtime}/${endingtime}`;
  if (userId) {
    url += `/${userId}`;
  }
  
  const result = await axios.get(url, config);
  return result.data;
};

const getLikeAnalytics = async (startingtime, endingtime, userId = null) => {
  const getToken = localStorage.getItem("token");
  const config = {
    headers: { Authorization: `Bearer ${getToken}` },
  };
  
  let url = `${SERVER_API_URL}/admin/analytics/getLikeAnalytics/${startingtime}/${endingtime}`;
  if (userId) {
    url += `/${userId}`;
  }
  
  const result = await axios.get(url, config);
  return result.data;
};

// Follow Analytics
const getFollowAnalytics = async (startingtime, endingtime, userId = null) => {
  const getToken = localStorage.getItem("token");
  const config = {
    headers: { Authorization: `Bearer ${getToken}` },
  };
  
  let url = `${SERVER_API_URL}/admin/analytics/getFollowAnalytics/${startingtime}/${endingtime}`;
  if (userId) {
    url += `/${userId}`;
  }
  
  const result = await axios.get(url, config);
  return result.data;
};

const getFollowAnalyticsByUser = async (startingtime, endingtime, userId = null) => {
  const getToken = localStorage.getItem("token");
  const config = {
    headers: { Authorization: `Bearer ${getToken}` },
  };
  
  let url = `${SERVER_API_URL}/admin/analytics/getFollowAnalyticsByUser/${startingtime}/${endingtime}`;
  if (userId) {
    url += `/${userId}`;
  }
  
  const result = await axios.get(url, config);
  return result.data;
};

// User Interaction Analytics
const getUserInteractions = async (startingtime, endingtime, userId = null) => {
  const getToken = localStorage.getItem("token");
  const config = {
    headers: { Authorization: `Bearer ${getToken}` },
  };

  let url = `${SERVER_API_URL}/admin/analytics/getUserInteractions/${startingtime}/${endingtime}`;
  if (userId) {
    url += `/${userId}`;
  }
  // url += "?unit=hours";

  const result = await axios.get(url, config);
  return result.data;
};

// Demographics
const getViewersDetails = async () => {
  const getToken = localStorage.getItem("token");
  const config = {
    headers: { Authorization: `Bearer ${getToken}` },
  };
  
  const url = `${SERVER_API_URL}/admin/analytics/getViewersDetails`;
  const result = await axios.get(url, config);
  return result.data;
};

export {
  getTotalViews,
  getFeedTotalViews,
  getCoinAnalytics,
  getSentCoinsAnalytics,
  getCommentAnalytics,
  getLikeAnalytics,
  getFollowAnalytics,
  getFollowAnalyticsByUser,
  getUserInteractions,
  getViewersDetails,
};
